import React from "react";
import portfolioData from "./data/portfolioData";
import Projects from "./components/Projects";
import Hero from './components/Hero'
import ImageCredits from './components/ImageCredits'
import Header from "./components/Header";
import Contact from "./components/Contacts"
import imageCreditsList from "./data/images";

const App = () => (
  <div className="min-h-screen bg-gray-900 font-inter">
    <script src="https://cdn.tailwindcss.com"></script>
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');
      .font-inter {
        font-family: 'Inter', sans-serif;
      }
      html {
        scroll-behavior: smooth;
      }
    `}</style>
    <Header />
    <main>
      <Hero />
      <Projects projects={portfolioData} />
      <Contact />
    </main>
    <ImageCredits credits={imageCreditsList} />
      <footer className="py-6 text-center text-gray-500 border-t border-gray-800 mt-10">
                <p>&copy; {new Date().getFullYear()} A. Berisha. Built with React and Tailwind CSS.</p>
        </footer>
  </div>
);

export default App;
